import { render, staticRenderFns } from "./OrderResumeView.vue?vue&type=template&id=35ba81b0&scoped=true"
import script from "./OrderResumeView.vue?vue&type=script&lang=js"
export * from "./OrderResumeView.vue?vue&type=script&lang=js"
import style0 from "./OrderResumeView.vue?vue&type=style&index=0&id=35ba81b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ba81b0",
  null
  
)

export default component.exports